// src/store/useAppointmentStore.js
import  create  from 'zustand';

export const useAppointmentTime = create((set) => ({
  selectedDayAppointments: [],
  setSelectedDayAppointments: (appointments) => set({ selectedDayAppointments: appointments }),
}));
